/*
组件内路由守卫  进入组件之前调用 主要解决在路由中启用组件缓存后，
如果查看列表详情 并且修改了信息后，再返回组件 没有查询数据的问题

*/
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.query()
    })
  }
}
